// extracted by mini-css-extract-plugin
export default {"container":"UE-z","disabled":"VE-z","bgBlack":"WE-z","content":"XE-z","countdown":"YE-z","topCaption":"ZE-z","topHeading":"_E-z","heading":"aF-z","copy":"bF-z"};